import { PlanSeq } from '@mobi/api-types'
import { BuildBetSelectionOptions } from '@core/Areas/ShareBet/LoadBet/buildBetSelection/types'
import type { BetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import type { QuickbetSelection } from '@core/Areas/Quickbet/types'
import { FixedOddsMarketDisplayNames } from '@core/Areas/RaceCard/constants'
import { getSelectionDetails } from './helpers/getSelectionDetails'
import { parseSelectionsString, getToteSelection, getFOBSelection } from './helpers/getSelection'

export const buildStandardRacingBet = async (
  betDetails: BetDetails,
  opts: BuildBetSelectionOptions = {}
) => {
  const { fixtureId, fixtureDate, races, planSeq, selectionString } = betDetails

  const selections = parseSelectionsString(selectionString)

  // Multi Race bets (Double, Quaddie & All Up) should have a selection string
  // with the same # of divisions (eg. Quaddie => 1.2/3/2/1.2.3)
  if (races.length > 1 && selections.length !== races.length)
    throw new Error('Provided selection details invalid')

  const shouldForceWinOnly =
    !!(betDetails.srmSelections && betDetails.srmSelections.length >= 2) ||
    betDetails.betType === FixedOddsMarketDisplayNames.SP

  const { selectionDetails, shouldAllowPlaceInvestment, fixedOddsMarkets } =
    await getSelectionDetails(
      fixtureId,
      fixtureDate,
      races,
      selections,
      planSeq,
      shouldForceWinOnly
    )

  const selection =
    betDetails.planSeq === PlanSeq.FOBRacing
      ? await getFOBSelection(betDetails, opts, fixedOddsMarkets)
      : await getToteSelection(betDetails)

  const quickbetSelection: QuickbetSelection = {
    bettingType: PlanSeq.FOBRacing === planSeq ? 'fixed-odds-racing' : 'tote-racing',
    selection: selection,
    selectionDetails,
    isEachWayAvailable: false,
    shouldAllowPlaceInvestment: betDetails.derivativePropositionSeq
      ? false
      : shouldAllowPlaceInvestment,
  }

  return quickbetSelection
}
